import { PendingAction } from '@/lib/api/dashboard/dashboard-api'
import {
    MdArrowForward,
    MdNotificationsActive,
    MdWarning,
} from 'react-icons/md'
import { Link } from 'react-router-dom'

interface PendingActionsWidgetProps {
    actions: PendingAction[]
}

export default function PendingActionsWidget({ actions }: PendingActionsWidgetProps) {
    if (actions.length === 0) return null

    const priorityStyles = {
        high: {
            bg: 'bg-error/10',
            border: 'border-error/30',
            icon: 'text-error',
            badge: 'badge-error',
        },
        medium: {
            bg: 'bg-warning/10',
            border: 'border-warning/30',
            icon: 'text-warning',
            badge: 'badge-warning',
        },
        low: {
            bg: 'bg-info/10',
            border: 'border-info/30',
            icon: 'text-info',
            badge: 'badge-info',
        },
    }

    return (
        <div className="bg-gradient-to-r from-warning/5 to-error/5 rounded-xl border border-warning/20 p-4">
            <div className="flex items-center gap-2 mb-3">
                <MdNotificationsActive className="text-warning text-xl" />
                <h3 className="font-semibold text-base-content">
                    Ações Pendentes
                </h3>
            </div>

            <div className="flex flex-wrap gap-2">
                {actions.map((action, index) => {
                    const styles = priorityStyles[action.priority]
                    return (
                        <Link
                            key={index}
                            to={action.href}
                            className={`group flex items-center gap-2 px-3 py-2 rounded-lg ${styles.bg} border ${styles.border} hover:shadow-md transition-all`}
                        >
                            <MdWarning className={styles.icon} />
                            <span className="text-sm text-base-content">
                                {action.message}
                            </span>
                            <span className={`badge badge-sm ${styles.badge}`}>
                                {action.count}
                            </span>
                            <MdArrowForward className="text-base-content/30 group-hover:text-base-content/60 transition-colors" />
                        </Link>
                    )
                })}
            </div>
        </div>
    )
}
